import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import ReactHtmlParser from 'react-html-parser';
import ExploreMore from "../exploreMore";
import BlogNewsletter from "../blogNewsletter";
import apiManager from "../../../utils/apiManager";
import Social from "../social";
import { AllCategoryBlogAPI, blogDetailAPI, imagePrefix, trendingBlogsAPI } from "../../../../public/constants/constants";
import "../../../../public/styles/blog/blogDetailPage.scss";
import { useState } from "react";
import HandPicked from "./handPickedSlider";
import MoreFromGodrej from "./moreFromGodrej";
import BlogShare from "./blogShare";
import HandPickedMini from "./handPickedMini";
import { isMobile } from "../../../utils/utilityManager";
import RelatedBlogs from "./relatedBlogs";
import Slider from "react-slick";



function BlogDetailPage(props) {

  const [blogDetail, setBlogDetail] = useState("")
  const [postDataAll, setPostDataAll] = useState([]);
  const [trendingBlogs, setTrendingBlogs] = useState([]);
  const [showData, setShowData] = useState([]);
  const [BlogDetailPageBanner, setBlogDetailPageBanner] = useState(null);

  const leftArrow = "/B2C/EspotImages/Images/rcb/arrows/arowLeft1.png";
  const rightArrow = "/B2C/EspotImages/Images/rcb/arrows/arrowRight1.png";

  useEffect(() => {
    getAllBlogList();
    getTrendingBlogs();
  }, [])

  useEffect(() => {
    getBlogDetail(props.id);
  }, [postDataAll])


  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],

    nextArrow: <div className='next'><img src={imagePrefix + rightArrow} alt="next"></img> </div>,
    prevArrow: <div className='next'> <img src={imagePrefix + leftArrow} alt="Prev"></img> </div>,
  };

  const getAllBlogList = () => {
    apiManager
      .get(AllCategoryBlogAPI)
      .then(response => {
        const {data} = response.data;
        const dataSliced = data.slice(1);
        setPostDataAll(dataSliced);
        setShowData(data.slice(1, 5));
      })
      .catch(error => { });
  };

  const getBlogDetail = id => {
    apiManager
      .get(`${blogDetailAPI  }${id}`)
      .then(response => {
        const detail = response.data.data;
        setBlogDetail(detail[0]);
        setBlogDetailPageBanner(detail[0].banner.url);
        if (Array.isArray(detail[0].fromCategory) && detail[0].fromCategory.length > 1) {
          const newArr = [];
          detail[0].fromCategory.map(category => {
            postDataAll.map(blog => {
              if (blog.categories.includes(category)) {
                newArr.push(blog);
              }
            });
          })
          setShowData([...newArr]);
        }
      })
      .catch(error => {
        console.log("error", error);
      });
  };

  const getTrendingBlogs = () => {
    apiManager
      .get(trendingBlogsAPI)
      .then(response => {
        setTrendingBlogs(response.data.data);
      })
      .catch(error => {
        console.log("trendingBlogs", error);
      });
  };

  const renderSlider = (content) => {
    const element = ReactHtmlParser(content.value);
    const imagesList = element[0].props.children[0].props.children;
    const imgArr = [];
    imagesList && imagesList.forEach((element) => {
      const tempObj = element.props.children[0].props.children;
      if (tempObj[0].type == "img") {
        const imgObj = {};
        imgObj.imgSrc = tempObj[0].props.src;
        imgObj.imgAlt = tempObj[0].props.alt;
        if (tempObj.length >= 2) { imgObj.figCaptionSrc = tempObj[1].props.children[0]; }
        imgArr.push(imgObj)
      };
    });
    return (
      <div className="blog-content-slider">
        <Slider {...settings}>
          {imgArr && Array.isArray(imgArr) && imgArr.map((imgObj, index) => (
            <figure key={index} className="bsSlides"><div className="product">
              <img src={imgObj.imgSrc} alt={imgObj.imgAlt}></img>
            </div>
            {<div className="fig-caption">{imgObj.figCaptionSrc && imgObj.figCaptionSrc}</div> }
            </figure>
          ))}
        </Slider>
            
      </div>
    )
  }


  return (
    <div className="blog-detail-page">
      <div className="banner">
        {console.log(BlogDetailPageBanner, 'blogDetail.banner new')}
        {blogDetail && blogDetail.banner.url &&
                    blogDetail.banner.url && <img src={isMobile() ? blogDetail.banner_rwd.url : blogDetail.banner.url} />}
      </div>
      {isMobile() ? <div className="blog-detail-mobile">
        {blogDetail && blogDetail.title && <div className="title">{blogDetail.title}</div>}
        <div className="author-detail">
          {blogDetail.profileUserName && <div className="name">{blogDetail.profileUserName}{"  "} | {" "} </div>}
          <BlogShare socialShareIcons={props.socialShareIcons} isOnTop blogTitle={blogDetail.title}  blogIntro={blogDetail.short_description} blogBanner={BlogDetailPageBanner}/>
        </div>
        <div className="related-topics">
          <div className="title-related-topic">Related Topics</div><div className="content">{!!blogDetail && Array.isArray(blogDetail.tags) &&
                        blogDetail.tags.map((tag, index) => (
                          <div
                            className="tag"
                            key={`category-${index}`}
                            id={tag + index}
                          >
                            <Link
                              to={`/blog/tag/${tag
                                .replaceAll(" ", "-")
                                .toLowerCase()}`}>{tag}</Link>
                          </div>
                        ))}</div>
        </div>
        <div className="main-content">
          {blogDetail && blogDetail.title && <div className="ParagraphOne">{blogDetail.ParagraphOne}</div>}
          {blogDetail && blogDetail.htmlcontent &&
                        blogDetail.htmlcontent.map((content, index) => (
                          content.value.includes("wp-block-getwid-images-slider") ? renderSlider(content) : <div dangerouslySetInnerHTML={{ __html: content.value }} className="html-content"></div>
                        ))
          }
          <div className="date"> <span className="date-title">Published on : </span>{!!blogDetail && blogDetail.date && new Date(blogDetail.date).toLocaleDateString({},{timeZone:"UTC",month:"long", day:"2-digit", year:"numeric"})
          }</div>
          <hr className="h-line" />
          <div className="tags"> <div className="tags-title">Tags</div> <div className="tag-names">{!!blogDetail && Array.isArray(blogDetail.tags) &&
                        blogDetail.tags.map((tag, index) => (
                          <div
                            className="tag"
                            key={`category-${index}`}
                            id={tag + index}
                          >
                            <Link
                              to={`/blog/tag/${tag
                                .replaceAll(" ", "-")
                                .toLowerCase()}`}>{tag}</Link>
                          </div>
                        ))}</div></div>

          <div className="liked-signup">
            <div className="liked-signup-text">Liked what you read? Sign up for our newsletter.</div>
            <div className="liked-signup-button button">
              <a href="#newsletterSubscribe" >BE INSPIRED. SUBSCRIBE.</a>
            </div>
          </div>
          <div className="social-share"><div className="name">Share this article<span>{"  "} | {" "} </span></div><BlogShare socialShareIcons={props.socialShareIcons} blogTitle={blogDetail.title}  blogIntro={blogDetail.short_description} blogBanner={BlogDetailPageBanner}/></div>
        </div>
      </div> : <div className="blog-detail">
        <div className="related-topics blog-detail-left"> <div className="title-related-topic">Related Topics</div>{!!blogDetail && Array.isArray(blogDetail.tags) &&
                    blogDetail.tags.map((tag, index) => (
                      <div className="tag">
                        <Link

                          key={`category-${index}`}
                          id={tag + index}
                          to={`/blog/tag/${tag
                            .replaceAll(" ", "-")
                            .toLowerCase()}`}
                        >
                          {tag}
                        </Link>
                      </div>

                    ))}
        </div>
        <div className="main-content">
          {blogDetail && blogDetail.title && <div className="title">{blogDetail.title}</div>}
          {blogDetail && blogDetail.title && <div className="ParagraphOne">{blogDetail.ParagraphOne}</div>}
          <div className="social-share"><BlogShare socialShareIcons={props.socialShareIcons} isOnTop blogTitle={blogDetail.title}  blogIntro={blogDetail.short_description} blogBanner={BlogDetailPageBanner}/></div>
          {blogDetail && blogDetail.htmlcontent &&
                        blogDetail.htmlcontent.map((content, index) => (
                          content.value.includes("wp-block-getwid-images-slider") ? renderSlider(content) : <div dangerouslySetInnerHTML={{ __html: content.value }} className="html-content"></div>
                        ))
          }
          <div className="tags"> <div className="tags-title">Tags</div><div className="tag-names">{!!blogDetail && Array.isArray(blogDetail.tags) &&
                        blogDetail.tags.map((tag, index) => (
                          <div
                            className="tag"
                            key={`category-${index}`}

                            id={tag + index}
                          >
                            <Link
                              to={`/blog/tag/${tag
                                .replaceAll(" ", "-")
                                .toLowerCase()}`}>{tag}</Link>

                          </div>
                        ))}</div></div>
          <div className="date"> <span className="date-title">Published on : </span>{!!blogDetail && blogDetail.date && new Date(blogDetail.date).toLocaleDateString({},{timeZone:"UTC",month:"long", day:"2-digit", year:"numeric"})
          }</div>
          <div className="liked-signup">
            <div className="liked-signup-text">Liked what you read? Sign up for our newsletter.</div>
            <div className="liked-signup-button button">
              <a href="#newsletterSubscribe" >BE INSPIRED. SUBSCRIBE.</a>
            </div>
          </div>
          {/* <FormGroup className="liked-signup-button"> */}
          {/* <button 
                  onClick={() => doneBtnPressed()}
                  >BE INSPIRED. SUBSCRIBE.</button> */}
          {/* </FormGroup> */}
                    
          <div className="social-share">Share this article <BlogShare socialShareIcons={props.socialShareIcons} blogTitle={blogDetail.title}  blogIntro={blogDetail.short_description} blogBanner={BlogDetailPageBanner}/></div>
        </div>
        <div className="blog-detail-right">


          {blogDetail && blogDetail.profileUserName && <div className="author-detail">
            {blogDetail && blogDetail.ProfileUserImage && <img src={blogDetail.ProfileUserImage} className="image"></img>}
            {blogDetail && blogDetail.profileUserName && <div className="name">{blogDetail.profileUserName}</div>}
            {blogDetail && blogDetail.profileUserDesignation && <div className="designation">{blogDetail.profileUserDesignation}</div>}
            {blogDetail && blogDetail.ProfileUserInfo && <div className="description">{blogDetail.ProfileUserInfo}</div>}
          </div>}


          {blogDetail.righthandpickedProductPartNumbers && Array.isArray(blogDetail.righthandpickedProductPartNumbers) && <HandPickedMini partNumber={blogDetail.righthandpickedProductPartNumbers[0]} />}

        </div>
      </div>}
      {blogDetail && blogDetail.handpickedProductPaths && Array.isArray(blogDetail.handpickedProductPaths) &&
                <HandPicked
                  productPaths={blogDetail && blogDetail.handpickedProductPaths}
                  productLinks={blogDetail && blogDetail.handpickedProductLinks}
                  productLables={blogDetail && blogDetail.handpickedProductLables}
                  productCount={blogDetail && blogDetail.handpickedProductCount}
                  productPartNumbers={blogDetail && blogDetail.handpickedProductPartNumbers}
                />}

      <div className="more-section">

        <RelatedBlogs allBlogsList={postDataAll} blogDetail={blogDetail} />

      </div>

      <div className="explore-more trending-blogs">
        <ExploreMore
          homeImages={props.homeImages}
          isFromDetailPage
          isTrendingBlogs
          trendingBlogs={trendingBlogs}
        />
      </div>

      <MoreFromGodrej />

      <BlogNewsletter
        categoryNameList={props.categoryNameList}
        homeImages={props.homeImages}
      />

      <div className="social-icons">
        <Social
          socialIcons={props.socialIcons}
          homeImages={props.homeImages}
        />
      </div>
    </div>
  );
}

export default BlogDetailPage;
